module.exports = __webpack_public_path__ + "img/time-blue.66b26ede.svg";